import React from 'react';
import styles from './Copyright.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const Copyright = () => {
    return (
        <>
            <hr />
            <div className="container">
                <div className="text-center">
                    <div className="mt-4">
                        <p className={cx('text-footer','mb-4')}>
                            Địa chỉ: 51 Quốc Hương - Phường Thảo Điền - Tp. Thủ Đức - TP. Hồ Chí Minh | Email:
                            lienhe@sociallife.vn | Số điện thoại: 0983634482
                        </p>
                    </div>
                    <div className="mt-2">
                        <p className={cx('text-footer','mb-4')}>
                            Địa chỉ: 71/62E Điện Biên Phủ - P.15 - Q. Bình Thạnh - TP.HCM | Email: lienhe@sociallife.vn
                        </p>
                    </div>
                    <div className="d-flex justify-content-center mb-2 pt-1">
                        <a className="me-2 ms-2 a" href="#" target="_blank">
                            <i className="fab fa-facebook fs-1"></i>
                        </a>
                        <a className="me-2 ms-2 a" href="#" target="_blank">
                            <i className="fab fa-youtube fs-1"></i>
                        </a>
                        <a className="me-2 ms-2 a" href="#" target="_blank">
                            <i className="fab fa-instagram fs-1"></i>
                        </a>
                        <a className="me-2 ms-2 a" href="#" target="_blank">
                            <i className="fab fa-tiktok fs-1"></i>
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Copyright;
